import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "@/lib/auth";

export default function ProtectedRoute({
  children,
  requireSuperadmin = false,
  allowEventUser = false,
  blockScanner = false,
  blockTrafficCoordinator = false,
}) {
  const { me, session, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center">
        <Loader2 className="h-6 w-6 animate-spin text-svj-cyan" />
      </div>
    );
  }
  if (!session || !me) {
    return <Navigate to="/admin/login" replace state={{ from: location.pathname }} />;
  }
  if (requireSuperadmin && !me.is_superadmin && !(allowEventUser && me.role === "event_user")) {
    return <Navigate to="/admin/scan" replace />;
  }
  // Scanner accounts may only reach the /admin/scan module. Bounce them anywhere else.
  if (blockScanner && me.role === "scanner") {
    return <Navigate to="/admin/scan" replace />;
  }
  // traffic_coordinator ("verkeersbeheerder") is confined to StapKompas Verkeer —
  // Verkeersregelaars/Live Flow/Incidenten/Chat (see require_traffic_access in
  // backend/server.py) — never full event management (tickets, orders, mailings,
  // route building). Bounce it to its own home page anywhere else, same pattern
  // as the scanner restriction above.
  if (blockTrafficCoordinator && me.role === "traffic_coordinator") {
    return <Navigate to="/admin/traffic-control" replace />;
  }
  return children;
}
